import MuiDialogTitle from "@mui/material/DialogTitle";

export default function DialogTitle(props) {
  return <MuiDialogTitle {...props} />;
}
